//引入vue
import Vue from 'vue';
import axios from 'axios';
import store from '../../src/store'
import sm2 from './sm2'
//新创建一个vue实例
let v = new Vue();

//创建axios实例
let dev = process.env.BASE_API
var service = axios.create({
    baseURL: dev,
    timeout: 5000,
    headers: {
        'content-type': 'application/json'
        // "token":'14a1347f412b319b0fef270489f'
    }
})
// http request 拦截器---补充--除登录、注册接口，其余接口添加token信息
// 请求拦截器
service.interceptors.request.use(
    config => {
        let path = location.href
        if (path.indexOf('/login') < 0 && path.indexOf('/homeLogin') < 0) {
            let token = store.getters.getUser.token
            let childToken = store.getters.getChildUser
            if (childToken) {
                config.headers.token = childToken
                console.log('use childToken');
            } else if (token) {
                config.headers.token = token
                console.log('use token');
            }
            if (path.indexOf('/basic_pipeline/add?workspace_id') > -1) {
                config.headers.withCredentials = true
            }
        }
        return config
    },
    error => {
        return Promise.error(error)
    })
// http response 拦截器
service.interceptors.response.use(
    response => {
        let code = response.data.code;
        if (code == 401 || (code == 500 && response.data.message == '缺少用户token信息')) {
            // 返回 401 清除token信息并跳转到登录页面
            // v.$notify.error({
            //     title: "错误",
            //     message: "登录信息已过期，请重新登录！！！",
            //     type: "error"
            // });
            location.hash = '#/login'
            store.commit("$_removeStorage")
            return
        }
        return response;
    },
    error => {
        let s = document.getElementsByClassName('el-notification__icon el-icon-error')
        if (s && s.length > 0) {
            return Promise.reject(error);
        }
        if (error.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
            //   v.$notify.error({
            //     title: "错误",
            //     message: "网络请求超时，请稍后再试！！！",
            //     type: "error"
            //   });
            return Promise.reject(error);          // reject这个错误信息
        }
        let res = error.response;
        switch (res.status) {
            case 400:
                // v.$notify.error({
                //   title: "错误",
                //   message: "未请求到资源，请重试！！！",
                //   type: "error"
                // });
                break
            case 401:
                // 返回 401 清除token信息并跳转到登录页面
                // v.$notify.error({
                //   title: "错误",
                //   message: "登录信息已过期，请重新登录！！！",
                //   type: "error"
                // });
                location.hash = '#/login'
                store.commit("$_removeStorage")
                break
            case 403:
                // v.$notify.error({
                //   title: "错误",
                //   message: "您没有该操作权限！！！",
                //   type: "error"
                // });
                break
            case 500:
                // v.$notify.error({
                //   title: "失败",
                //   message: "服务器连接异常，请稍后再试！！！",
                //   type: "error"
                // });
                // alert('服务器错误');
                break
            case 504:
                // v.$notify.error({
                //   title: "失败",
                //   message: "服务器连接异常，请稍后再试！！！",
                //   type: "error"
                // });
                // alert('服务器错误');
                break
            default:
                // v.$notify.error({
                //   title: "错误",
                //   message: '服务器连接异常，请稍后再试！！！',
                //   type: "error"
                // });
                break
        }
        return Promise.reject(error.response.data) // 返回接口返回的错误信息
    });
export default {
    //get请求，其他类型请求复制粘贴，修改method
    getJSON (url, param) {
        if (url.indexOf('?') > -1) {
            url = url + '&time=' + new Date().getTime()
        } else {
            url = url + '?time=' + new Date().getTime()
        }
        return new Promise((cback, reject) => {
            service({
                method: 'get',
                url,
                params: param,
            }).then(res => {
                //axios返回的是一个promise对象
                var res_code = res.status.toString();
                if (res_code.charAt(0) == 2) {
                    res.data.data = sm2.decryptText(res.data.data)
                    cback(res);   //cback在promise执行器内部
                }
            }).catch(err => {
                // if (err.response) {
                reject(err);
                // }
            })
        })
    },
    postJSON (url, param, time) {
        let locked = {
            param: sm2.encryptText(param)
        }
        return new Promise((cback, reject) => {
            service({
                method: 'post',
                url,
                params: {},
                data: locked,//param,
                timeout: time ? time : 5000
            }).then(res => {
                //axios返回的是一个promise对象
                var res_code = res.status.toString();
                if (res_code.charAt(0) == 2) {
                    res.data.data = sm2.decryptText(res.data.data)
                    cback(res);   //cback在promise执行器内部
                }
            }).catch(err => {
                // if (err.response) {
                reject(err);
                // }
            })

        })
    },
    putJSON (url, param) {
        return new Promise((cback, reject) => {
            service({
                method: 'put',
                url,
                params: {},
                data: param,
            }).then(res => {
                //axios返回的是一个promise对象
                var res_code = res.status.toString();
                if (res_code.charAt(0) == 2) {
                    cback(res);   //cback在promise执行器内部
                }
            }).catch(err => {
                if (err.response) {
                    reject(err.response);
                }
            })

        })
    },
    deleteJSON (url, param) {
        return new Promise((cback, reject) => {
            service({
                method: 'delete',
                url,
                params: param,
            }).then(res => {
                //axios返回的是一个promise对象
                var res_code = res.status.toString();
                if (res_code.charAt(0) == 2) {
                    cback(res);   //cback在promise执行器内部
                }
            }).catch(err => {
                if (err.response) {
                    reject(err.response);
                }
            })

        })
    },
    getJSONone (url, param, cancelToken, type) {
        if (url.indexOf('?') > -1) {
            url = url + '&time=' + new Date().getTime()
        } else {
            url = url + '?time=' + new Date().getTime()
        }
        return new Promise((cback, reject) => {
            service({
                method: 'get',
                url,
                params: param,
                cancelToken: cancelToken,
                responseType: type || "",
            }).then(res => {
                //axios返回的是一个promise对象
                var res_code = res.status.toString();
                if (res_code.charAt(0) == 2) {
                    cback(res); //cback在promise执行器内部
                }
            }).catch(err => {
                console.log(err);
                if (err.response) {
                    reject(err.response);
                }
            })
        })
    },
    postJSONone (url, param, obj, time, cancelToken) {
        return new Promise((cback, reject) => {
            service({
                method: 'post',
                url,
                params: {},
                data: param,
                cancelToken: cancelToken,
                timeout: time ? time : 5000
            }).then(res => {
                //axios返回的是一个promise对象
                var res_code = res.status.toString();
                if (res_code.charAt(0) == 2) {
                    res.data.data = sm2.decryptText(res.data.data)
                    cback(res); //cback在promise执行器内部
                }
            }).catch(err => {
                if (err.response) {
                    reject(err.response);
                }
            })
        })
    },
    postJSONO (url, param, obj, time, cancelToken) {
        return new Promise((cback, reject) => {
            service({
                method: 'post',
                url,
                params: {},
                data: param,
                cancelToken: cancelToken,
                timeout: time ? time : 5000
            }).then(res => {
                //axios返回的是一个promise对象
                var res_code = res.status.toString();
                if (res_code.charAt(0) == 2) {
                    cback(res); //cback在promise执行器内部
                }
            }).catch(err => {
                if (err.response) {
                    reject(err.response);
                }
            })
        })
    },
}



// WEBPACK FOOTER //
// ./src/common/http.js